import Cookies from 'js-cookie'
import * as Lockr from 'lockr'
import { getOrSetSessionId } from '../../login/get-session-id'

type NewRelicEventData = {
  [key: string]: string | number | boolean
  client_timestamp: number
  user_id: string
  session_id: string
}
export const logNewRelicEvent = (
  eventName: string,
  data: Record<string, string | number | boolean>,
) => {
  if (typeof window === 'undefined') {
    return
  }

  // Client-side logging
  const updatedData: NewRelicEventData = {
    ...data,
    client_timestamp: Date.now(),
    user_id: Cookies.get('user_id') ?? Lockr.get('user_id') ?? '',
    session_id: getOrSetSessionId(),
    architecture: 'monorepo-stencil',
  }
  if (!updatedData.traceId || updatedData.traceId === 'unset') {
    updatedData.traceId = Cookies.get('trace_id') ?? 'unset'
  }

  if (process.env.NODE_ENV === 'development') {
    return
  }
  if (window.newrelic) {
    window.newrelic.addPageAction(eventName, updatedData)
  } else {
    console.info('Newrelic not found')
  }
}
